import { ListaItensVt, TrajetoInstruc } from '../../types';
import List from './components/list';
import { Container } from './styles';

interface IDetailedInstructions {
  instructions: TrajetoInstruc[];
  handleOpenDeleteModal: (instruction: TrajetoInstruc) => void;
  handleOpenEditModal: (instruction: TrajetoInstruc) => void;
  vtItensOptions: ListaItensVt[];
  manualRoutingType: 'detailed' | 'simple';
}

export default function DetailedInstructions({
  instructions,
  vtItensOptions,
  handleOpenDeleteModal,
  handleOpenEditModal,
  manualRoutingType,
}: IDetailedInstructions) {
  return (
    <Container>
      <List
        instructions={instructions}
        vtItensOptions={vtItensOptions}
        handleOpenDeleteModal={handleOpenDeleteModal}
        handleOpenEditModal={handleOpenEditModal}
        manualRoutingType={manualRoutingType}
      />
    </Container>
  );
}
